import { FC } from 'react';

import { AppFormattedMessage } from '../../../components/app-formatted-message/index';
import Button from '../../../components/button/index';

type HurdleWarningModalProps = {
  onClose: () => void;
};

export const HurdleWarningModal: FC<HurdleWarningModalProps> = ({ onClose }) => {
  return (
    <div className="flex w-full max-w-[453px] flex-col items-end gap-4 rounded-[4px] bg-white p-4">
      <div className="flex flex-col gap-1 text-xs font-[450] text-gray-500">
        <span className="text-xl font-semibold text-gray-700">
          <AppFormattedMessage id="HURDLE_GRANTS" />
        </span>
        <span>
          <AppFormattedMessage id="HURDLE_HAS_BEEN_TRIGGERED" />
        </span>
      </div>
      <div className="p-3 text-xs font-[450] text-gray-700">
        <AppFormattedMessage id="GRANTS_HAVE_BEEN_ADDED_TO_GRANTS" />
      </div>
      <span className="front-[450] w-full text-xs text-gray-500">
        <AppFormattedMessage id="IF_YOU_PREFER_YOU_CAN_DESELECT_THEM" />
      </span>

      <Button className="mt-4 w-[105px]" onClick={onClose}>
        <AppFormattedMessage id="OKAY" />
      </Button>
    </div>
  );
};
